export default {
  bind: function (el, binding, vnode) {
    const { arg } = binding
    if (!arg) throw new Error('指令参数是必须的 示例：v-el-form-item-blur-validate:layerId')
    const { componentInstance } = vnode
    componentInstance.$on('blur', async () => {
      await componentInstance.$nextTick()
      setTimeout(() => {
        componentInstance.elForm && componentInstance.elForm.validateField(arg)
      }, 150)
    })
    //
  },
  unbind: function (el, binding, vnode) {
    const { componentInstance } = vnode
    componentInstance.$off('blur')
  }
}
